<template>
    <div class="import">
        <!-- 1. logo部分 -->
        <div class="login-logo-view">
            <img class="login-logo" src="../assets/images/logo.png">
        </div>
        <!-- 2. 导入三清宫数据 -->
        <div class="login-form-note">
            <p>请输入三清宫八字注册账户信息</p>
        </div>
        <div class="login-form-border">
            <input class="login-form-input border-bottom" v-model="inputData.m" type="tel" placeholder="输入手机号码" @blur="blurTel">
            <input class="login-form-input" v-model="inputData.p" type="password" placeholder="输入密码" @blur="blurPassword">
        </div>
        <div class="login-form-sub-note">
            <i class="iconfont" v-bind:class="{'icon-selected':agree, 'icon-unselected':!agree}" @click="toggleAgree"></i>
            我已阅读并同意<span @click="showAgreePop">数据导入免责声明</span>
        </div>
        <div class="login-form-btn">
            <button class="button-green" v-bind:class="{'button-gray':!agree}" v-bind:disabled="!agree" v-on:click="submitImport()">授权本地检测导入</button>
        </div>

        <!-- 3. 导入数据成功提示 -->
        <van-overlay v-show="showPopup"/>
        <import-popup v-show="showPopup" ></import-popup>

        <!-- 6. 说明弹框 -->
        <div class="layout-overlay" v-if="showPop" @click="clickShowAgreePopOverlay"></div>
        <div class="layout-popup detail-note-pop import-note-pop" v-if="showPop">
            <div class="detail-note-pop-title">
                <i class="iconfont icon-arrowflower-left detail-note-pop-icon"></i>
                <span>数据导入免责声明</span>
                <i class="iconfont icon-arrowflower-right detail-note-pop-icon"></i>
            </div>
            <div class="detail-note-pop-content">
                <p>天时子平八字用户（以下简称“您”）在使用数据导入服务时，应当充分阅读、理解并接受本协议的全部内容，一旦您使用本服务，即表示您同意遵循本协议项下与深圳市天时子平科技文化有限责任公司（以下简称“天时子平”）的所有约定。</p>
                <p>1.自您勾选同意本服务内容点击确认则代表您以充分理解并接受协议中的所有内容，且该点击确认行为与您加盖公章或签字的行为具有相同法律效力。</p>
                <p>2.您同意，天时子平有权基于国家法律法规变化、业务调整、产品更新及维护交易秩序、保护消费者权益等需要，不时对本协议内容进行变更，并以在天时子平官方渠道公告的方式予以公布；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务。</p>
                <p>3.您了解，导入数据为免费服务，为学习研究使用，您主动从第三方服务商导入数据；天时子平仅提供导入通道，数据的导入导出操作权由用户控制，所有操作均由您充分授权。由于底层技术设置等原因，数据会产生损毁、更改等风险，天时子平会竭尽全力帮助您找回或修复数据。对于未找回或未修复的数据，由于数据迁移的复杂以及难以预测性，因此天时子平不承担任何法律责任，包括赔付责任。</p>
                <p>4.您保证，您从其他第三方服务商迁移到天时子平的数据已经是经过数据拥有者授权。若因此产生的任何风险由您自己承担，与天时子平无关。</p>
                <p>5.因天时子平仅承担数据导入义务，不对导入数据正确性做判断，因此您需保证导入数据的正确性。</p>
                <p>6.为了给您提供更好的学习体验及服务，天时子平有权在保证隐私的前提下对该导入的数据进行使用，包括进行数据分析等。</p>
            </div>
        </div>
    </div>
</template>

<script>
import { UTILS } from '../modules/utils'
import message from '../modules/api/msg_srv'
import ImportPopup from '../layouts/import/ImportPopup.vue'

export default {
    name: 'Import',
    components: { ImportPopup },
    computed: {
        showPopup() {
            return this.$store.state.import.showPopup;
        }
    },
    data() {
        return {
            agree: true,
            showPop: false,
            inputData: {
                'm': '', 'p': ''
            },
            notesData: {
                "telephone": "请输入11位手机号码",
                "password": "请输入密码",
                "agree": "请先阅读并同意数据导入免责声明"
            }
        }
    },
    methods:{
        toggleAgree() {
            this.agree = !this.agree;
        },
        showAgreePop() {
            this.showPop = true;
        },
        clickShowAgreePopOverlay() {
            this.showPop = false;
        },
        blurTel() {
            window.scrollTo(0, 0);
        },
        blurPassword() {
            window.scrollTo(0, 0);
        },
        submitImport() {
            
            // 校验数据
            if(this.inputData.m == ''){
                this.$toast(this.notesData['telephone']);
                return;
            }else if(!UTILS.isPoneAvailable(parseInt(this.inputData.m))){
                this.$toast(this.notesData['telephone']);
                return;
            }

            if(this.inputData.p == ''){
                this.$toast(this.notesData['password']);
                return;
            }

            if(!this.agree) {
                this.$toast(this.notesData['agree']);
                return;
            }

            var me = this;       
            var importParams = {
                params: this.inputData,
                sucCallBack: function(data){
                    if(data.ret){
                        me.$store.state.import.showPopup = true;
                        me.$toast.loading({
                            position: "middle",
                            duration: 3000,
                            message: '导入成功\n正在跳转...',
                            onClose: function(){
                                window.location.pathname = "/record";
                            }
                        });
                    }
                },
                failCallBack: function(data){
                    if(data.status_code){
                        me.$toast(message[data.status_code]);
                    }
                }
            }
            this.$store.dispatch('submitImport', importParams);

        }
    }
}
</script>